import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './dialog/dialog.component';
import { FontSizeComponent } from './font-size/font-size.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { UiTableComponent } from './ui-table/ui-table.component';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { ErrorComponent } from './error/error.component';
import { UiCalendarComponent } from './ui-calendar/ui-calendar.component';
import { CalendarModule } from 'primeng/calendar';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CalendarMaskDirective } from './calendar-mask.directive';
import { SelectComponent } from './select/select.component';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContactComponent } from './contact/contact.component';
import { InputMaskModule } from 'primeng/inputmask';
import { AddressComponent } from './address/address.component';
import { NgBusyModule } from 'ng-busy';
import { MessageModule } from 'primeng/message';
import { MemoComponent } from './memo/memo.component';
import { PanelModule } from 'primeng/panel';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { EditorModule } from 'primeng/editor';
import { MessageComponent } from './message/message.component';
import { RequiredLabelComponent } from './required-label/required-label.component';
import { PhoneComponent } from './phone/phone.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ViewTemperatureLogDetailsComponent } from '../temperatureLog/view-temperature-log-details/view-temperature-log-details.component';
import { MemoWrapperComponent } from './memo-wrapper/memo-wrapper.component';
import { WordPipe } from '../../pipes/word.pipe';
import { FocusDirective } from '../../directives/focus/focus.directive';
import { ModalFocusDirective } from '../../directives/modal-focus.directive';
import { DropdownSortPipe } from '../../pipes/dropdown-sort.pipe';
import { FilePickerDirective } from '../../directives/file-picker.directive';
import { CapsLockDirective } from '../../directives/capsLock/caps-lock.directive';
import { NotesComponent } from './notes/notes.component';
import { EnrollmentComponent } from './enrollment/enrollment.component';
import { FormDirective } from 'src/app/directives/form/form.directive';
import { ViewReportComponent } from './report/view-report/view-report.component';
import { TrimPipe } from '../../pipes/trim.pipe';
import { MessagesModule } from 'primeng/messages';
import { TelephonePipe } from 'src/app/pipes/telephone.pipe';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PasswordInputAttrDirective } from './password-input-attr.directive';
import { RippleModule } from 'primeng/ripple';
import { MonkeypoxAgreementComponent } from './monkeypox-agreement/monkeypox-agreement.component';
import { AccordionModule } from 'primeng/accordion';

@NgModule({
  declarations: [
    DialogComponent,
    FontSizeComponent,
    UiTableComponent,
    ErrorComponent,
    WordPipe,
    UiCalendarComponent,
    CalendarMaskDirective,
    FocusDirective,
    ModalFocusDirective,
    SelectComponent,
    ContactComponent,
    AddressComponent,
    DropdownSortPipe,
    MemoComponent,
    TextEditorComponent,
    FilePickerDirective,
    MessageComponent,
    RequiredLabelComponent,
    PhoneComponent,
    CapsLockDirective,
    ViewTemperatureLogDetailsComponent,
    MemoWrapperComponent,
    NotesComponent,
    EnrollmentComponent,
    FormDirective,
    ViewReportComponent,
    TrimPipe,
    TelephonePipe,
    PasswordInputAttrDirective,
    MonkeypoxAgreementComponent
  ],
  imports: [
    CommonModule,
    BsDropdownModule,
    TableModule,
    PaginatorModule,
    CalendarModule,
    ReactiveFormsModule,
    FormsModule,
    PopoverModule,
    DropdownModule,
    MultiSelectModule,
    InputMaskModule,
    MessageModule,
    PanelModule,
    EditorModule,
    NgBusyModule,
    RadioButtonModule,
    CheckboxModule,
    OverlayPanelModule,
    MessagesModule,
    RippleModule,
    AccordionModule
  ],
  exports: [
    FontSizeComponent,
    UiTableComponent,
    ErrorComponent,
    WordPipe,
    UiCalendarComponent,
    FocusDirective,
    ModalFocusDirective,
    SelectComponent,
    ContactComponent,
    AddressComponent,
    DropdownSortPipe,
    MemoComponent,
    TextEditorComponent,
    FilePickerDirective,
    MessageComponent,
    RequiredLabelComponent,
    PhoneComponent,
    CapsLockDirective,
    ViewTemperatureLogDetailsComponent,
    NotesComponent,
    EnrollmentComponent,
    FormDirective,
    ViewReportComponent,
    TrimPipe,
    TelephonePipe,
    PasswordInputAttrDirective,
    MonkeypoxAgreementComponent
  ],
})
export class SharedModule {}
